<template>
  <div class="container col-lg-8 col-sm-12 mb-10">
    <div v-if="isEditingUserDetails">
      <v-skeleton-loader type="list-item" v-for="i in 10" :key="i" />
    </div>
    <Permissioned section="workers.edit" vertical v-else>
      <div
        v-for="(section, index) in allSections"
        :oneOfPermissions="getPermissions(section)"
        :key="index"
      >
        <component :is="section.component" :userData="userData" isEditable />
        <v-divider class="mt-4" />
      </div>
    </Permissioned>
  </div>
</template>

<script>
import BasicDetails from "@/views/settings/components/BasicDetails";
import ContactDetails from "@/views/settings/components/ContactDetails";
import Preferences from "@/views/settings/components/Preferences";
import Experience from "@/views/settings/components/Experience";
import Qualifications from "@/views/settings/components/Qualifications";
import CriminalConvictions from "@/views/settings/components/CriminalConvictions";
import LanguagesAndSkills from "@/views/settings/components/LanguagesAndSkills";
import Diversity from "@/views/settings/components/Diversity";
import CV from "@/views/settings/components/CV";
import DataProcessing from "@/views/settings/components/DataProcessing";
import { PERMISSIONS } from "@/constants/workers";
import Permissioned from "@/components/common/Permissioned";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { USERS_NAMESPACE } from "@/store/modules/users";
import Matching from "@/views/settings/components/Matching";
import { FETCH_CURRENT_USER } from "@/store/modules/users/actions";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const {
  mapState: mapUserState,
  mapActions: mapUserActions
} = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "Profile",
  components: {
    Permissioned
  },
  created() {
    this.fetchCurrentUser();
  },
  data() {
    return {
      allSections: [
        {
          component: BasicDetails,
          permissions: PERMISSIONS.BASIC_DETAILS
        },
        {
          component: ContactDetails,
          permissions: PERMISSIONS.CONTACT_DETAILS
        },
        {
          component: Preferences,
          permissions: PERMISSIONS.PREFERENCES
        },
        {
          component: Matching,
          permissions: PERMISSIONS.MATCHING
        },
        {
          component: Experience,
          permissions: PERMISSIONS.EXPERIENCE
        },
        {
          component: Qualifications,
          permissions: PERMISSIONS.QUALIFICATIONS
        },
        {
          component: LanguagesAndSkills,
          permissions: PERMISSIONS.LANGUAGES_AND_SKILLS
        },
        {
          component: CriminalConvictions,
          permissions: PERMISSIONS.CRIMINAL_CONVICTIONS
        },
        {
          component: Diversity,
          permissions: PERMISSIONS.DIVERSITY
        },
        { component: CV, permissions: PERMISSIONS.CV },
        { component: DataProcessing }
      ]
    };
  },
  computed: {
    ...mapUserState(["isEditingUserDetails"]),
    ...mapAuthState({
      userData: state => state.userData
    })
  },
  methods: {
    ...mapUserActions({
      fetchCurrentUser: FETCH_CURRENT_USER
    }),
    getPermissions({ permissions }) {
      if (permissions) {
        return Object.values(permissions);
      }
    }
  }
};
</script>

<style lang="scss"></style>
